<template>
  <div v-bind:class="['list', ...classes]">
    <div class="item" v-for="item in orderedList">
      <div v-bind:class="{counter: true, blue: color === 'blue', black: color === 'black', white: color === 'white'}">{{item.counter}}</div>
      <div class="text">{{item.text}}</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'BeautifulOrderedList',
  props: ['text', 'array', 'color', 'classes'],
  data() {
    return {
    }
  },

  computed: {
    items: function () {
      if (this.array) return this.array;
      return this.text.split('\n').map(line => {
        return line.trim().replace(/^[\d]+./, '').trim();
      });
    },

    orderedList: function () {
      let items = [];
      for (let i = 0; i < this.items.length; i++) {
        items.push({
          counter: `${i+1}`,
          text: this.items[i]
        })
      }

      return items
    },
  },

  methods: {

  },

  created() {
  }
}
</script>

<style lang="scss">
@import "src/assets/scss/index.scss";

</style>
